<template>
  <div
    id="search-bar"
    class="w-100 px-2 safari_only_search"
    :class="{'up-position': false}"
  >
    <div class="input-group mb-0 w-100">
      <div
        class="input-group-prepend input-group-prepend-full specific-input"
        style="border-bottom: solid 1px #e8e8e8;"
      >
        <b-form-select
          v-model="cityId"
          class="form-control"
          :options="cities"
        />

        <b-form-select
          v-model="level"
          class="form-control"
          :options="levelOfInterestIds"
        />

        <b-form-select
          v-model="contracting"
          class="form-control"
          :options="contractingRegimes"
        />

        <b-form-select
          v-if="currentUserIsCandidate"
          v-model="fitCandidate"
          :options="fitCandidateArea"
          class="form-control"
        />
      </div>
      <div class="input-group-prepend specific-input">
        <div class="input-group-prepend">
          <span
            id="basic-addon1"
            class="input-group-text safari_only_icon"
          >
            <i
              class="fa fa-search"
              aria-hidden="true"
            />
          </span>
        </div>
        <input
          v-model="word"
          type="text"
          class="form-control"
          placeholder="Digite uma palavra-chave"
          @keyup.enter="filterVacancies()"
        >
      </div>
      <div class="input-group-append specific-input">
        <button
          class="btn bg-color-secondary text-white w-100 m-0 p-0 h-100"
          type="button"
          :style="{'background-color': `${getPrimaryColor}` + ' !important'}"
          @click="filterVacancies()"
        >
          Buscar vagas
          <i
            class="fa fa-arrow-right"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VueAxios from 'vue-axios';
import mixins from '../mixins/mixins';

Vue.use(VueAxios, axios);

export default {
  name: 'SearchBar',
  mixins: [mixins],
  data() {
    return {
      word: '',
      cityId: '',
      cities: [
        {
          text: 'Selecione uma cidade',
          value: '',
        },
      ],
      level: '',
      levelOfInterestIds: [
        { text: 'Selecione o nível da vaga', value: '' },
        { text: 'Aprendiz', value: 1 },
        { text: 'Estagiário', value: 2 },
        { text: 'Auxiliar', value: 3 },
        { text: 'Assistente', value: 4 },
        { text: 'Técnico', value: 5 },
        { text: 'Trainee', value: 6 },
        { text: 'Analista', value: 7 },
        { text: 'Especialista', value: 8 },
        { text: 'Supervisor', value: 9 },
        { text: 'Consultor', value: 10 },
        { text: 'Coordenador', value: 11 },
        { text: 'Gerente', value: 12 },
        { text: 'Diretor', value: 13 },
        { text: 'Presidente', value: 14 },
        { text: 'Operacional', value: 15 },
      ],
      contracting: '',
      contractingRegimes: [
        { text: 'Selecione o tipo de contrato', value: '' },
        { text: 'CLT', value: 'clt' },
        { text: 'Estagiário', value: 'estagiario' },
        { text: 'Freelancer', value: 'freelancer' },
        { text: 'PJ', value: 'pj' },
        { text: 'Temporário', value: 'temporario' },
        { text: 'Terceiro', value: 'terceiro' },
        { text: 'Período determinado', value: 'periodo_determinado' },
        { text: 'Horista', value: 'horista' },
      ],
      fitCandidate: 'open_to_candidates',
      fitCandidateArea: [
        { text: 'Minha área de interesse', value: 'interest_for_candidate' },
        { text: 'Todas as vagas abertas', value: 'open_to_candidates' },
      ],
    };
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompany',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'currentUserIsCandidate',
      'userIsLoggedIn',
    ]),
    ...mapGetters('CompanyStore', [
      'currentScopedCompanyManagerOther',
      'getPrimaryColor',
    ]),
  },
  async mounted() {
    const self = this;
    const arrCities = [{ text: 'Selecione uma cidade', value: '' }];
    await axios
      .get(`${window.location.origin}/api_v/v1/vagas/localizacao`)
      .then((response) => {
        response.data.forEach((element) => {
          let k = Object.keys(element)[0];
          let v = Object.values(element)[0];
          arrCities.push({ value: k, text: v });
        });
        self.cities = arrCities;
      })
      .catch((error) => {})
      .finally(() => {});
  },
  methods: {
    filterVacancies() {
      this.$store.dispatch('VacancyStore/loadVacancies', {
        from: 'searchbar',
        word: this.word,
        cityId: this.cityId,
        level: this.level,
        contracting: this.contracting,
        fitCandidate: this.fitCandidate,
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #search-bar {
    z-index: 0;

    &.up-position {
      z-index: 1 !important;
    }

    .input-group {
      border: 0;
      box-shadow: 0px 1px 19px rgba(0, 0, 0, 0.17) !important;

      input.form-control,
      select.form-control {
        height: calc(2.53125rem + 26px);
      }

      .input-group-prepend {
        margin-right: -1px !important;

        &.specific-input {
          width: 75% !important;

          @media screen and (max-width: 576px) {
            width: 100% !important;
          }
        }
      }

      .input-group-prepend-full {
        &.specific-input {
          width: 100% !important;
        }

        select.form-control {
          border-right: solid 1px #e8e8e8;
        }
      }

      select.form-control {
        background-position-x: 95%;
        background-position-y: 30px;
        background-repeat: no-repeat;
        background-size: 12px 8px;
      }

      .input-group-append {
        &.specific-input {
          width: 25% !important;

          @media screen and (max-width: 576px) {
            width: 100% !important;
          }
        }

        button.btn.bg-color-secondary {
          border-radius: 0;

          @media screen and (max-width: 576px) {
            padding: 1rem !important;
          }
        }
      }
    }
  }

// Mobile Safarai - Iphones
@media screen and (max-width: 576px) {
  _::-webkit-full-page-media, _:future, :root .safari_only_search {
    position: initial !important;
    bottom: none !important;
  }
  _::-webkit-full-page-media, _:future, :root .safari_only_icon {
    padding-right: 0;
    height: 60px;
    padding: 10px 2px;
  }
}
</style>
